<div class="items h-100" [class.empty]="projects?.length === 0">
    @if (projects?.length > 0) {
        <div class="item-list">
            @for (project of projects; track project) {
                <a
                    class="item"
                    routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{ Routenames.projects }}/{{
                        project.id
                    }}/{{ Routenames.timeline }}">
                    {{ project.name }}
                    <div class="icon"></div>
                </a>
            }
            <div class="item-spacer"></div>
        </div>
    } @else {
        <div class="not-found">
            <div class="text-center">Er staat nog niets ingepland voor dit project</div>
        </div>
    }
</div>
